import React from 'react';
import MediaQuery from 'react-responsive';
import { withRouter } from 'react-router-dom';

import { STATIC_ROOT } from '../constants';
import SvgComponent from './SvgComponent';

import { ScrollToTopLink } from './ScrollToTopComponentStyle';

/**
 * This component must be include only one time in the application (cf. './App.js')
 * You must nouse it anywhere else
 * This component is used to restore the scroll position when navigating
 */
class ScrollToTopComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            display: this.getOffset() > 300
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.toggleDisplay);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    componentWillUnMount() {
        window.removeEventListener(this.toggleDisplay);
    }

    getOffset = () =>
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        (document.documentElement.body && document.documentElement.body.scrollTop) ||
        0;

    toggleDisplay = () => {
        const offset = this.getOffset();
        this.setState({ display: offset > 300 });
    };

    render() {
        return (
            <MediaQuery query="(max-width: 768px)">
                <ScrollToTopLink
                    href="#entete"
                    title="Aller en haut"
                    className={`scroll${this.state.display ? '' : ' hidden'}`}
                    onClick={() =>
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                    }>
                    <SvgComponent
                        src={`${STATIC_ROOT}/fleche.svg`}
                        className="haut"
                        width="12"
                        height="22"
                    />
                </ScrollToTopLink>
            </MediaQuery>
        );
    }
}

export default withRouter(ScrollToTopComponent);



// WEBPACK FOOTER //
// ./src/components/ScrollToTopComponent.js